<template>
	<app-page>
		<app-heading :title="isNew ? 'New Tag' : tag.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-tags' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="tag.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="tag.slug"
					required
					:errors="errors.slug"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.tag = await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('tags')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			tag: {
				name: '',
				slug: '',
			},
			errors: {},
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
		id() {
			return this.$route.params.tag
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('tags')
						.create({
							name: this.tag.name,
							slug: this.tag.slug,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('tags')
						.to(this.id)
						.update({
							name: this.tag.name,
							slug: this.tag.slug,
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Tag successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-tags' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
